import { render, staticRenderFns } from "./form-row.vue?vue&type=template&id=53880bf4&scoped=true&"
import script from "./form-row.vue?vue&type=script&lang=js&"
export * from "./form-row.vue?vue&type=script&lang=js&"
import style0 from "./form-row.vue?vue&type=style&index=0&id=53880bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53880bf4",
  null
  
)

export default component.exports